var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tag_container",class:_vm.isKaiDuo?'green':'red'},[_vm._v("\n        "+_vm._s(_vm.isKaiDuo?_vm.$t('contract.OpenMore'):_vm.$t('contract.OpenEmpty'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }